import React, { useCallback, useMemo, useState } from 'react';
import EditableField from 'src/components/fields/EditableField';
import { Input } from 'antd';

export interface InputEditableFieldProps {
  value: string;
  placeholder?: string;
  className?: string;
  onEditModeChange?: (e: boolean) => void;
  onBlur?: (e: string | undefined) => void;
  level?: 2 | 1 | 5 | 3 | 4 | undefined;
}

const commonLevelStyle = {
  color: 'rgba(0, 0, 0, 0.85)',
  fontWeight: 600,
};
const levelsStyle = {
  1: {
    ...commonLevelStyle,
    fontSize: 38,
    lineHeight: 1.23,
  },
  2: {
    ...commonLevelStyle,
    fontSize: 30,
    lineHeight: 1.35,
  },
  3: {
    ...commonLevelStyle,
    fontSize: 24,
    lineHeight: 1.35,
  },
  4: {
    ...commonLevelStyle,
    fontSize: 20,
    lineHeight: 1.4,
  },
  5: {
    ...commonLevelStyle,
    fontSize: 16,
    lineHeight: 1.5,
  },
};

const InputEditableField: React.FC<InputEditableFieldProps> = (props: InputEditableFieldProps) => {
  const { value, onBlur, onEditModeChange, className, placeholder, level } = props;
  const [innerValue, setInnerValue] = useState<string>(value);
  const submit = useCallback(() => {
    if (value !== innerValue) {
      onBlur && onBlur(innerValue);
    }
  }, [innerValue, onBlur, value]);

  const titleStyle = useMemo(() => (level ? levelsStyle[level] : {}), [level]);

  return (
    <EditableField
      value={value || '-'}
      onEditModeChange={onEditModeChange}
      className={className}
      level={level}
      onEscape={() => setInnerValue(value)}
    >
      <Input
        autoFocus
        type='text'
        value={innerValue}
        placeholder={placeholder}
        onChange={e => setInnerValue(e.target.value)}
        onBlur={() => submit()}
        style={{ padding: '3px 7px', ...titleStyle }}
      />
    </EditableField>
  );
};

export default InputEditableField;
